import { useSelector } from 'react-redux';
import FirstContactus from './FirstContactus'
import SecondContactus from './SecondContactus'
import Style3Contactus from './Style3Contactus'
import Style4Contactus from './Style4Contactus'

function ContactUsPageWrapper() {
    const sitedata = useSelector((store) => store.global.loginData);
    return (

        <>
            {sitedata?.theme_contact_us === "style-1" ? (
                <FirstContactus />
            ) : sitedata?.theme_contact_us === "style-2" ? (
                <SecondContactus />
            ) : sitedata?.theme_contact_us === "style-3" ? (
                <Style3Contactus />
            ) : sitedata?.theme_contact_us === "style-4" ? (
                <Style4Contactus />
            ) : (
                <FirstContactus />
            )}

        </>
    )
}

export default ContactUsPageWrapper